import React, { useEffect, useMemo, useState,useCallback } from "react";
import PageTitle from "../../layouts/PageTitle";
import { ToastContainer } from "react-toastify";
import Select from "react-select";
import Table from "../../components/table/ReactTable/Table";
import { useDispatch, useSelector } from "react-redux";
import { masterActions,inventoryHistoryActions } from "../../../_store";
import { ColumnFilter } from "../../components/table/ReactTable/ColumnFilter";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { RangeDatePicker } from "@y0c/react-datepicker";
import { Button } from "react-bootstrap";
import { format } from "date-fns";
import { fCurrency } from "../../../utils/formatNumber";

import transactionReportPDF from "../../components/export/transactionReportPDF";
import transactionReportXslx from "../../components/export/transactionReportXlsx";
import Toastr from "../../components/common/Toastr";


function SalesProductReport() {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [startEndDate, setStartEndDate] = useState({ FromDate: new Date(), ToDate: new Date(),TransactionTypeID:0 });
  const dispatch = useDispatch();
  const transactionReportList = useSelector(
    (x) => x.inventoryHistory.transactionReportList
  );
  //#region Popup
    let transactionTypeDrpList = useSelector(
      (x) => x.master.transactionTypeDrpList
    );
    transactionTypeDrpList=transactionTypeDrpList?.filter(d=>d.value!==2);

const [finalTableData, setFinalTableData] = useState([]);
  const handleTableDataUpdate = useCallback((data) => {
        setFinalTableData(data);
      }, []);

  useEffect(() => {
    let TransactionTypeID = 0;
        let TransactionStatus = 0;
        dispatch(
          masterActions.GetTransactionTypeDrpList({ TransactionTypeID, Status:TransactionStatus })
        );

  }, [dispatch]);

  const PRODUCTS_COLUMNS = [
     {
          Header: "Product Name",
          Footer: "Product Name",
          accessor: "ProductName",
          justify: "center",
          Filter: ColumnFilter,
        },
        {
          Header: "Category",
          Footer: "Category",
          accessor: "CategoryName",
          justify: "center",
          Filter: ColumnFilter,
    },
   {
         Header: "SKU",
         Footer: "SKU",
         accessor: "SKU",
         justify: "center",
         Filter: ColumnFilter,
       },
       {
        Header: "Quantity",
        Footer: "Quantity",
        accessor: "Quantity",
        justify: "center",
        Filter: ColumnFilter,
      },
    {
      Header: "Value",
      Footer: "Value",
      accessor: "Price",
      justify: "center",
     Cell: ({ value }) => { return value && fCurrency(value) },
      
      Filter: ColumnFilter,
      
    }
    
    
  ];

  const columns = useMemo(() => PRODUCTS_COLUMNS, []);

 

  const generateColumns = [
    {
      header: "Product Name",
      dataKey: "ProductName",
      cellWidth: 60,
    },
    {
      header: "Category",
      dataKey: "CategoryName",
      cellWidth: 60,
    },
    {
      header: "SKU",
      dataKey: "SKU",
      cellWidth: 50,
    },
    {
      header: "Quantity",
      dataKey: "Quantity",
      cellWidth: 40,
    },
    {
      header: "Value",
      dataKey: "Price",
      cellWidth: 40,
    }
    
  ];


  const onChangeRangeValue = (title) => (...date) => {
    let value = { ...startEndDate };
    value.FromDate = date[0];
    value.ToDate = date[1];
    setStartEndDate(value)

}

// handle Dropdown Change function
const handleDrpChange = (event, title) => {
  let value = { ...startEndDate };
  if (title === "TransactionTypeID") {
    value.TransactionTypeID=parseInt(event.value);
  } 
  setStartEndDate(value)
};


  const handleClickPDF = () => {

    if (startEndDate.FromDate && startEndDate.ToDate && startEndDate.TransactionTypeID && startEndDate.TransactionTypeID>0) {
    let title = "Transaction Report";
    const columnStyles = {
      ProductName: { halign: "center", cellWidth: 50 },
      CategoryName: { halign: "center", cellWidth: 50 },
      SKU: { halign: "center", cellWidth: 40 },
      Quantity: { halign: "center", cellWidth: 25 },
      Price: { halign: "center", cellWidth: 30 }
    };
    const transactionHeaderData = {
      FromDate:format(new Date(startEndDate?.FromDate), 'MM/dd/yyyy'),
      ToDate:format(new Date(startEndDate?.ToDate), 'MM/dd/yyyy'),
      TransactionType:GetTransactionTypeValue(startEndDate?.TransactionTypeID),
    };

    const tableData = finalTableData?.map(row => ({
      ...row,
      Price:row.Price && fCurrency(row.Price)
    }));
   
      transactionReportPDF(
        tableData,
        generateColumns,
        false,
        title,
        transactionHeaderData,
        columnStyles)

      }else
      {
        if((!startEndDate.TransactionTypeID) || (startEndDate.TransactionTypeID && startEndDate.TransactionTypeID===0))
          {
            Toastr('Please select a transaction type.', 'warning');
          }else
          {
            Toastr('Please select a date range.', 'warning');
          }
      }
      
    
  };

  function GetTransactionTypeValue(TransactionTypeID)
  {
   return (TransactionTypeID===1?"Purchase":(TransactionTypeID===3?"Adjustment Credit":(TransactionTypeID===4?"Adjustment Debit":(TransactionTypeID===5?"Sales":""))) )
  }

  const handleClickExcel = () => {
    if (startEndDate.FromDate && startEndDate.ToDate && startEndDate.TransactionTypeID && startEndDate.TransactionTypeID>0) {
    let title = "Transaction Report";
    let generateExcelColumns = [
      "Product Name",
      "Category Name",
      "SKU",
      "Quantity",
      "Value",
    ];
    let new_transactionReportList =
      
    finalTableData && finalTableData.map(function (obj) {
        return {
          ProductName: obj.ProductName,
          CategoryName: obj.CategoryName,
          SKU: obj.SKU,
          Quantity: obj.Quantity,
          Price: obj.Price,
        };
      });

    const transactionHeaderData = {
      "From Date":format(new Date(startEndDate?.FromDate), 'MM/dd/yyyy'),
      "To Date":format(new Date(startEndDate?.ToDate), 'MM/dd/yyyy'),
      "Transaction Type":GetTransactionTypeValue(startEndDate?.TransactionTypeID),
    };
    
      transactionReportXslx(
        new_transactionReportList,
        transactionHeaderData,
        generateExcelColumns,
        title
      );
    
    }
    else {
         if((!startEndDate.TransactionTypeID) || (startEndDate.TransactionTypeID && startEndDate.TransactionTypeID===0))
         {
           Toastr('Please select a transaction type.', 'warning');
         }else
         {
           Toastr('Please select a date range.', 'warning');
         }
          
       }
  };

  const handleRangeDateSearch = () => {
    if (startEndDate.FromDate && startEndDate.ToDate && startEndDate.TransactionTypeID && startEndDate.TransactionTypeID>0) {
      showLoader();  
      dispatch(inventoryHistoryActions.getTransactionReportByTypeID(startEndDate)).then((response) => {
        hideLoader();
      });

    } else {
      if((!startEndDate.TransactionTypeID) || (startEndDate.TransactionTypeID && startEndDate.TransactionTypeID===0))
      {
        Toastr('Please select a transaction type.', 'warning');
      }else
      {
        Toastr('Please select a date range.', 'warning');
      }
       
    }
}
 

  return (
    <>
      <PageTitle
        activeMenu="Transaction Report"
        motherMenu="Products"
      />
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">
          Transaction Report
          </h4>
         
          <div className="float-sm-end">
          {transactionReportList && (transactionReportList.length >0) && (
             <>
                <Button
                  className="me-2"
                  variant="danger btn-rounded"
                  onClick={handleClickPDF}
                >
                  <span className="btn-icon-start text-danger">
                    <i className="fa fa-solid fa-file-pdf"></i>
                  </span>
                  PDF
                </Button>
                <Button
                  className="me-2"
                  variant="secondary btn-rounded"
                  onClick={handleClickExcel}
                >
                  <span className="btn-icon-start text-secondary">
                    <i className="fa fa-regular fa-file-excel"></i>
                  </span>
                  Excel
                </Button>
                </>
               )}
          </div>
         
        </div>
        <div className="card-body">
        <div className="row">
        <div className="col-md-3 mb-3">
              <label className="text-black font-w500">
                Transaction Type <span className="text-danger">*</span>
              </label>
              <Select
                classNamePrefix={"custom_select_css"}
                name="TransactionTypeID"
                // value={newFormData.TransactionTypeOption}
                onChange={(event) =>
                  handleDrpChange(event, "TransactionTypeID")
                }
                options={transactionTypeDrpList}
                // styles={
                //   submitted && newFormData.TransactionTypeID === 0 ? styles : ""
                // }
              />
            </div>
                        <div className="col-lg-3 col-md-8 mb-3">
                            <div className="example rangeDatePicker ms-2">
                                <label className="mb-1 text-black font-w500 productDate">Date Range<span className="text-danger"> *</span></label>
                                <RangeDatePicker
                                    initialStartDate={startEndDate.FromDate ? startEndDate.FromDate : new Date()}
                                    initialEndDate={startEndDate.ToDate ? startEndDate.ToDate : new Date()}
                                    name="StartEndDate"
                                    startText="Start"
                                    endText="End"
                                    dateFormat="MM/DD/YYYY"
                                    startPlaceholder="Start Date"
                                    endPlaceholder="End Date"
                                    portal
                                    onChange={onChangeRangeValue("date")}

                                />
                            </div>
                        </div>
                        <div className="col-md-3 mb-2">
                            <div className="d-flex mt-5">
                                <a className="btn btn-primary shadow btn-xs sharp me-1" title="Search" 
                                onClick={() => handleRangeDateSearch()} 
                                 >
                                    <i className="fas fa-search"></i>
                                </a>
                                {/* <a className="btn btn-danger shadow btn-xs sharp" title="Delete" onClick={() => handleRangeDateClear()} >
                                    <i className="fas fa-times"></i></a> */}
                            </div>
                        </div>

                    </div>
          
            <div className="row">
              <div className="mt-5">
                <Table
                  columns={columns}
                  data={transactionReportList}
                 onDataUpdate={handleTableDataUpdate}
                />
              </div>
            </div>
          
        </div>
      </div>
      {loader}
    </>
  );
}

export default SalesProductReport;
